import type { ApiResponse } from '@/shared/services/01_axios/api/response.api'
import type { UserModel } from '@/shared/types'
import { getAuthToken } from '@/shared/utils/storage'
import httpBare from '../01_axios/bare'
import http from '../01_axios/index'
import type { LoginRequest, LoginResponse } from './components/identity.param'
import {
  apiChangeHistory,
  apiChangePassword,
  apiCompleteGuestDetails,
  apiCompleteStaffDetails,
  apiGetInfo,
  apiGetTabs,
  apiLogin,
  apiLogout,
  apiRefreshToken,
  apiRegister,
  apiUpdateAvatar,
  apiUpdateInfo,
} from './components/urls'

const login = (payload: LoginRequest): Promise<ApiResponse<LoginResponse>> => {
  const body = new URLSearchParams()
  body.set('username', payload.username)
  body.set('password', payload.password)
  return http.post(apiLogin, body, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
}
const getInfo = (): Promise<ApiResponse<UserModel>> => http.get(apiGetInfo)
const refreshToken = async (refreshTokenValue: string): Promise<ApiResponse<LoginResponse>> => {
  const body = new URLSearchParams()
  body.set('refresh_token', refreshTokenValue)
  // Dùng httpBare (không interceptor) để refresh call không rơi vào vòng lặp 401
  // tự xếp mình vào queue. Vẫn kèm Authorization = access token cũ (BE yêu cầu).
  const res = await httpBare.post(apiRefreshToken, body, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${getAuthToken() ?? ''}`,
    },
  })
  return res.data
}
const getTabs = (): Promise<ApiResponse<any>> => http.get(apiGetTabs)
const changePassword = (payload: any): Promise<ApiResponse<any>> =>
  http.post(apiChangePassword, {
    currentPassword: payload.oldPassword,
    password: payload.newPassword,
  })

const updateInfo = (payload: any): Promise<ApiResponse<any>> => http.post(apiUpdateInfo, payload)
const updateAvatar = (payload: any): Promise<ApiResponse<any>> =>
  http.post(apiUpdateAvatar, payload)
const completeGuestDetails = (payload: any): Promise<ApiResponse<any>> =>
  http.post(apiCompleteGuestDetails, payload)
const completeStaffDetails = (payload: any): Promise<ApiResponse<any>> =>
  http.post(apiCompleteStaffDetails, payload)
const register = (payload: any): any => http.post(apiRegister, payload)
const changeHistory = (payload: any): any => http.post(apiChangeHistory, payload)
const logout = () => http.post(apiLogout)

const identityService = {
  login,
  getInfo,
  refreshToken,
  getTabs,
  changePassword,
  updateInfo,
  updateAvatar,
  completeGuestDetails,
  completeStaffDetails,
  register,
  changeHistory,
  logout,
}

export default identityService
